export const MobileAppUpdateStateEnum = Object.freeze({
  CHECKING: 'checking',
  NOT_AVAILABLE: 'no_update_available',
  UPDATE_AVAILABLE: 'update:non_mandatory',
  UPDATE_REQUIRED: 'update:mandatory',
});
